import React from 'react';
import styled, { keyframes } from 'styled-components';
import CustomSpin from './Ant/CustomSpin';

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const blink = keyframes`
  0%, 20%   { opacity: 0.2; }
  50%       { opacity: 1; }
  80%, 100% { opacity: 0.2; }
`;

const Wrapper = styled.div`
  /* جایگزین innerHeight - 180 و واکنش‌گرا */
  min-height: calc(100vh - 180px);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;

  /* ظاهر شدن نرم و با کمی تأخیر (لودهای خیلی کوتاه دیده نمی‌شوند) */
  opacity: 0;
  animation: ${fadeUp} 0.5s ease-out 0.2s forwards;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 1;
  }
`;

const Label = styled.span`
  color: #9aa1a9;
  font-size: 13px;
  letter-spacing: 0.2px;
  user-select: none;
`;

const Dots = styled.span`
  display: inline-flex;
  margin-inline-start: 2px;

  i {
    font-style: normal;
    animation: ${blink} 1.4s infinite both;
  }
  i:nth-child(2) { animation-delay: 0.2s; }
  i:nth-child(3) { animation-delay: 0.4s; }

  @media (prefers-reduced-motion: reduce) {
    i { animation: none; opacity: 0.6; }
  }
`;

const Spinner = React.memo(() => (
  <Wrapper className="sanjabSpin" role="status" aria-live="polite">
    <Content>
      <CustomSpin size={30} />
      <Label>
        در حال بارگذاری
        <Dots aria-hidden="true">
          <i>.</i>
          <i>.</i>
          <i>.</i>

          <i>.</i>
          <i>.</i>
          <i>.</i>
        </Dots>
      </Label>
    </Content>
  </Wrapper>
));

export default Spinner;